import { Button, Box, Typography } from "@mui/material";
import { useTranslationSetup } from "../../utils/useTranslationSetup";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CustomSelectorChip from "../../components/CustomSelectorChip/CustomSelectorChip";
import assessLangCloud1 from "../../assets/assess-lang-cloud1.svg";
import assessLangCloud2 from "../../assets/assess-lang-cloud2.svg";
import assessLangCloud3 from "../../assets/assess-lang-cloud3.svg";
import assessLangCloud4 from "../../assets/assess-lang-cloud4.svg";
import assessLangCloud5 from "../../assets/assess-lang-cloud5.svg";
import assessLangCloud6 from "../../assets/assess-lang-cloud6.svg";
import assessLangCloud7 from "../../assets/assess-lang-cloud7.svg";
import assessLangCloud8 from "../../assets/assess-lang-cloud8.svg";
import assessLangCloud9 from "../../assets/assess-lang-cloud9.svg";
import "./styles.css";
import useParamValues from "../../utils/useParamValues";
import { SCREENS } from "../../utils/CommonUtils/screenConstants";

const SelectAssessmentLangScreen = ({
  assessmentLang,
  setAssessmentLang,
  setActiveScreen,
}) => {
  const { organisation } = useParamValues();
  const { t } = useTranslationSetup();
  const guHiOrgIds = new Set(["pratham_demo_1"]);
  const enHiOrgIds = new Set([
    "bihar_demo_1",
    "bihar_pilot_1",
    "generic_demo",
    "demo",
  ]);
  const guEnOrgIds = new Set(["guj_vsk"]);
  function getAssessmentLangOptions(organisation) {
    if (guHiOrgIds.has(organisation)) {
      return assessmentLangGuHiOptions;
    } else if (enHiOrgIds.has(organisation)) {
      return assessmentLangEnHiOptions;
    } else if (guEnOrgIds.has(organisation)) {
      return assessmentLangGuEnOptions;
    } else {
      return assessmentLangGuEnOptions;
    }
  }
  const assessmentLangGuHiOptions = [
    {
      label: t("gujarati"),
      abbreviation: "(GU)",
      value: "gu",
    },
    {
      label: t("hindi"),
      abbreviation: "(हिं)",
      value: "hi",
    },
  ];

  const assessmentLangEnHiOptions = [
    {
      label: t("english"),
      abbreviation: "(EN)",
      value: "en",
    },
    {
      label: t("hindi"),
      abbreviation: "(हिं)",
      value: "hi",
    },
  ];

  const assessmentLangGuEnOptions = [
    {
      label: t("gujarati"),
      abbreviation: "(GU)",
      value: "gu",
    },
    {
      label: t("english"),
      abbreviation: "(EN)",
      value: "en",
    },
  ];
  const handleNavigateToSplashLoadingScreen = () => {
    setActiveScreen(SCREENS.RENDER_SPLASH_LOADING_SCREEN);
  };

  return (
    <>
      <Box className="choose-lang-container">
        <Box className="select-assessment-lang-heading-container">
          <Typography className="heading">{t("choose_language")}</Typography>
          <Typography className="heading-content">
            {t("select_language_you_want_assessment_with")}
          </Typography>
        </Box>
        <Box className="language-container">
          <CustomSelectorChip
            setValue={setAssessmentLang}
            options={getAssessmentLangOptions(organisation)}
          />
        </Box>
        <Box className="select-assessment-button-container">
          <Button
            endIcon={<ArrowForwardIcon />}
            className="button-style"
            disabled={assessmentLang === null ? true : false}
            disableElevation
            onClick={handleNavigateToSplashLoadingScreen}
          >
            {t("next")}
          </Button>
        </Box>
      </Box>
      <img
        src={assessLangCloud1}
        alt="assess-lang-cloud1-img"
        className="assess-lang-cloud1"
      />
      <img
        src={assessLangCloud2}
        alt="assess-lang-cloud2-img"
        className="assess-lang-cloud2"
      />
      <img
        src={assessLangCloud3}
        alt="assess-lang-cloud3-img"
        className="assess-lang-cloud3"
      />
      <img
        src={assessLangCloud4}
        alt="assess-lang-cloud4-img"
        className="assess-lang-cloud4"
      />
      <img
        src={assessLangCloud5}
        alt="assess-lang-cloud5-img"
        className="assess-lang-cloud5"
      />
      <img
        src={assessLangCloud6}
        alt="assess-lang-cloud6-img"
        className="assess-lang-cloud6"
      />
      <img
        src={assessLangCloud7}
        alt="assess-lang-cloud7-img"
        className="assess-lang-cloud7"
      />
      <img
        src={assessLangCloud8}
        alt="assess-lang-cloud8-img"
        className="assess-lang-cloud8"
      />
      <img
        src={assessLangCloud9}
        alt="assess-lang-cloud9-img"
        className="assess-lang-cloud9"
      />
    </>
  );
};

export default SelectAssessmentLangScreen;
